import type { StrongAuthenticationKind } from 'types/api/strong_authentication';
import { create } from 'zustand';

type PendingResolver = { resolve: VoidFunction; reject: VoidFunction };

interface StrongAuthState {
  authRequirement: StrongAuthenticationKind | null;
  pending: PendingResolver[];
}

interface StrongAuthActions {
  requireStrongAuth: (authRequirement: StrongAuthenticationKind) => Promise<void>;
  resolveStrongAuth: VoidFunction;
  close: VoidFunction;
}

type StrongAuthStore = StrongAuthState & StrongAuthActions;

const initialState: StrongAuthState = {
  authRequirement: null,
  pending: [],
};

export const useStrongAuthStore = create<StrongAuthStore>()((set, get) => ({
  ...initialState,
  requireStrongAuth: (authRequirement) =>
    new Promise<void>((resolve, reject) => {
      set((state) => ({ authRequirement, pending: [...state.pending, { resolve, reject }] }));
    }),

  resolveStrongAuth: () => {
    get().pending.forEach((resolver) => {
      resolver.resolve();
    });
    set(initialState);
  },

  close: () => {
    get().pending.forEach((resolver) => {
      resolver.reject();
    });
    set(initialState);
  },
}));
